/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { authService } from 'services/auth/AuthService';

const isGMUser = () => {
  const email = authService.getEmail()?.toString()?.toLocaleLowerCase();
  return email && email.includes('@gm.com') ? true : false;
};

export default isGMUser;
